import qs from 'qs'
import axios from 'axios'
import Request from '@/utils/Request'

// const yapi = 'http://yapi.upho2015.com/mock/32'
const gatewayApi = process.env.VUE_APP_GATEWAY_URL
const zhixinApi = process.env.VUE_APP_ZHIXIN_URL
const adminApi = process.env.VUE_APP_ADMIN_URL
const passportApi = process.env.VUE_APP_PASSPORT_URL
const staticApi = process.env.VUE_APP_STATIC_URL
const navigationApi = process.env.VUE_APP_NAVIGATION_URL
// let mockApi = ''
// if (process.env.NODE_ENV !== 'production') {
//   mockApi = 'http://yapi.upho2015.com/mock/32'
// }
const api = {
  quickLogin (data) {
    return ajax(`${passportApi}/Auth/quickLogin`, 'post', { data })
  },
  loginRegister (data) {
    return ajax(`${passportApi}/Register/register`, 'post', { data })
  },
  sendCode (params) {
    return ajax(`${passportApi}/Sms/get`, 'get', { params })
  },
  logout () {
    return ajax(`${passportApi}/Logout/logout`, 'get')
  },
  getUserInfo () {
    return ajax(`${zhixinApi}/v1/User/getInfo`, 'get')
  },
  weChatShare (params) {
    return ajax(`${zhixinApi}/v1/wechatshare/share`, 'get', { params })
  },
  // getPagedOrders (params) {
  //   return ajax(`${gatewayApi}/v1/offline/myCourse`, 'get', { params })
  // },
  getPagedOrders (params) {
    return ajax(`${zhixinApi}/v1/Charge/getPagedOrders`, 'get', { params })
  },
  queryOrder (params) {
    return ajax(`${zhixinApi}/v1/Charge/queryOrder`, 'get', { params })
  },
  charge (data) {
    return ajax(`${zhixinApi}/v1/Charge/charge`, 'post', { data })
  },
  getClassList (params) {
    return ajax(`${gatewayApi}/v1/offline/getList`, 'get', { params })
  },
  getClassDetail (params) {
    return ajax(`${gatewayApi}/v1/offline/getByClassId`, 'get', { params })
  },
  getLiveClassDetail (params) {
    return ajax(`${zhixinApi}/v1/Live/getClassInfo`, 'get', { params })
  },
  calCartPrice (json) {
    return ajax(`${gatewayApi}/v1/cart/calCartPrice`, 'post', { json })
  },
  CreateShoppingCartOrder (data) {
    return ajax(`${zhixinApi}/v1/Charge/CreateShoppingCartOrder`, 'post', { data })
  },
  getUserSubclass (params) {
    return ajax(`${zhixinApi}/v1/subclass/getUserSubclass`, 'get', { params })
  },
  booking (params) {
    return ajax(`${zhixinApi}/v1/Live/booking`, 'get', { params })
  },
  creatOrder (json) {
    return ajax(`${gatewayApi}/v1/charge/create`, 'post', { json })
  },
  cancelOrder (data) {
    return ajax(`${zhixinApi}/v1/charge/cancel`, 'post', { data })
  },
  getCourseLabel (timeStamp) {
    if (process.env.VUE_APP_JINGSAI === '竞赛') {
      return rawRequest(`${staticApi + navigationApi}?${timeStamp}`, 'get')
    } else {
      return rawRequest(`${staticApi}/json/ldl/SubjectNoJingSai.json?${timeStamp}`, 'get')
    }
  },
  getProvince () {
    return rawRequest(`${staticApi}/json/schools/provs`, 'get')
  },
  getCities (prov) {
    return rawRequest(`${staticApi}/json/schools/${prov}/cities`, 'get')
  },
  getDistricts (prov, city) {
    return rawRequest(`${staticApi}/json/schools/${prov}/${city}/districts`, 'get')
  },
  getSchool (prov, city, districts) {
    return rawRequest(`${staticApi}/json/schools/${prov}/${city}/${districts}`, 'get')
  },
  getGroupTop (params) {
    return ajax(`${gatewayApi}/v1/marketing/getNotGroupByGroupId`, 'get', { params })
    // return ajax(`${yapi}/v1/marketing/getNotGroupByGroupId`, 'get', { params })
  },
  getLiveGroupTop (params) {
    return ajax(`${zhixinApi}/v1/Live/getGroupsInfo`, 'get', { params })
  },
  getMyCourseLiveInfo (params) {
    return ajax(`${zhixinApi}/v1/Live/getClassInfo`, 'get', { params })
  },
  getMyCourseOfflineInfo (params) {
    return ajax(`${gatewayApi}/v1/offline/getByClassId`, 'get', { params })
  },
  getOrderInfo (params) {
    return ajax(`${zhixinApi}/v1/Charge/queryOrderNew`, 'get', { params })
  },
  getGroupInfoByGroupId (params) {
    return ajax(`${gatewayApi}/v1/marketing/getGroupInfoByGroupId`, 'get', { params })
  },
  getEnterClass (data) {
    return ajax(`${zhixinApi}/v1/Live/enterClass`, 'post', { data })
  },
  getReplayInfo (params) {
    return ajax(`${zhixinApi}/v1/Subclass/getReplayInfo`, 'get', { params })
  },
  getGatewayReplayInfo (params) {
    return ajax(`${gatewayApi}/v1/video/getReplayInfo`, 'get', { params })
  },
  getVideoPlayAuth (params) {
    return ajax(`${gatewayApi}/v3/video/getVideoPlayAuth`, 'get', { params })
  },
  getOfflineVideoPlayAuth (params) {
    return ajax(`${gatewayApi}/v3/video/getVideoPlayAuth`, 'get', { params })
  },
  getFeedback (params) {
    return ajax(`${zhixinApi}/v1/Live/getFeedback`, 'get', { params })
  },
  createFeedback (data) {
    return ajax(`${zhixinApi}/v1/Live/createFeedback`, 'post', { data })
  },
  updateFeedback (data) {
    return ajax(`${zhixinApi}/v1/Live/updateFeedback`, 'post', { data })
  },
  keepAlive (data) {
    return ajax(`${zhixinApi}/v1/Live/keepAlive`, 'post', { data })
  },
  keepLiveLive (params) {
    return ajax(`${gatewayApi}/v1/user-course/keeplive-live`, 'get', { params })
  },
  keepLivePlayback (params) {
    return ajax(`${gatewayApi}/v1/user-course/keeplive-playback`, 'get', { params })
  },
  getRoomRanking (data) {
    return ajax(`${zhixinApi}/v1/Liveroomgift/roomRanking`, 'post', { data })
  },
  getCoursewareSts (params) {
    return ajax(`${zhixinApi}/v1/Subclass/getCoursewareSts`, 'get', { params })
  },
  shareLive (subId) {
    return ajax(`${zhixinApi}/v1//Task/shareLive/${subId}`, 'get')
  },
  getRoomUserInfo (params) {
    return ajax(`${zhixinApi}/v1/User/getOther/${params.userId}/${params.roomId}`, 'get')
  },
  stopTalking (data) {
    return ajax(`${data.msgUrl}/v1/room/stop-talking`, 'post', { data })
  },
  getSocketList (params) {
    return ajax(`${process.env.VUE_APP_SOCKET_URL}/v1/server/get-list`, 'get', { params })
  },
  getChatMessage (params) {
    return ajax(`${params.msgUrl}/v1/room/get-message`, 'get', { params })
  },
  deleteRecord (data) {
    return ajax(`${data.msgUrl}/v1/room/del-message`, 'post', { data })
  },
  estoppelList (data) {
    return ajax(`${data.msgUrl}/v1/room/get-forbidden-list`, 'post', { data })
  },
  estoppelUser (data) {
    return ajax(`${data.msgUrl}/v1/room/stop-user-talking`, 'post', { data })
  },
  sendSocketMsg (data, params) {
    return ajax(`${data.msgUrl}/v1/push/room`, 'post', { data, params })
  },
  roomUpload (json, msgUrl) {
    return ajax(`${msgUrl}/v1/system/upload-images`, 'post', { json })
  },
  roomOnline (params) {
    return ajax(`${params.msgUrl}/v1/online/room`, 'get', { params })
  },
  getLiveList (params) {
    return ajax(`${zhixinApi}/v1/live/search`, 'get', { params })
  },
  getMyCourseLive (params) {
    return ajax(`${zhixinApi}/v1/Live/getUserLiveClass`, 'get', { params })
  },
  getMyCourseFree (params) {
    return ajax(`${zhixinApi}/v1/Live/getUserBooking`, 'get', { params })
  },
  getMyAllCourse (params) {
    return ajax(`${zhixinApi}/v1/Subclass/getUserSubclass`, 'get', { params })
  },
  getMyAllCourseNew (params) {
    return ajax(`${gatewayApi}/v1/subclass/getUserSubclass`, 'get', { params })
  },
  getMyCourse (params) {
    return ajax(`${gatewayApi}/v1/offline/myOfflineCourse`, 'get', { params })
  },
  getGifts () {
    return ajax(`${zhixinApi}/v1/Liveroomgift/gifts`, 'get')
  },
  getRoomGift (params) {
    return ajax(`${zhixinApi}/v1/Liveroomgift/roomGift`, 'get', { params })
  },
  getRoomSwitch (params) {
    return ajax(`${zhixinApi}/v1/Liveroomgift/getSwitch`, 'get', { params })
  },
  sendGift (data) {
    return ajax(`${zhixinApi}/v1/Liveroomgift/send`, 'post', { data })
  },
  GetCartPrice (data) {
    return ajax(`${zhixinApi}/v1/Cart/calCartPrice`, 'post', { data })
  },
  getRefundAmount (params) {
    return ajax(`${zhixinApi}/v1/Charge/getRefundAmount`, 'get', { params })
  },
  refund (data) {
    return ajax(`${zhixinApi}/v1/Charge/refund`, 'post', { data })
  },
  saveExpressNo (data) {
    return ajax(`${zhixinApi}/v1/Charge/saveExpressNo`, 'post', { data })
  },
  setDefault (data) {
    return ajax(`${zhixinApi}/v1/Address/setDefault`, 'post', { data })
  },
  getAddress (params) {
    return ajax(`${zhixinApi}/v1/Address/get`, 'get', { params })
  },
  getCoupon (params) {
    return ajax(`${gatewayApi}/v1/marketing/getUserCoupon`, 'get', { params })
  },
  getCouponInfo (params) {
    return ajax(`${gatewayApi}/v1/marketing/getCouponByUuid`, 'get', { params })
  },
  receiveCoupon (data) {
    return ajax(`${gatewayApi}/v1/marketing/userReceiveCoupon`, 'post', { data })
  },
  // 缓存面授课报名信息
  cacheOfflineOrder (json) {
    return ajax(`${gatewayApi}/v1/charge/cacheOfflineOrder`, 'post', { json })
  },
  // 获取缓存面授课报名信息
  getCacheOfflineOrder (params) {
    return ajax(`${gatewayApi}/v1/charge/getCacheOfflineOrder`, 'get', { params })
  },
  handleAddress (data, handle) {
    return ajax(`${zhixinApi}/v1/Address/${handle}`, 'post', { data })
  },
  getLiveUnion (params) {
    // return ajax(`${zhixinApi}/v1/Live/getUnion`, 'get', { params })
    return ajax(`${gatewayApi}/v1/marketing/getUnionByGoodsId`, 'get', { params })
  },
  // 获取面授课回放打折信息
  getOfflineReplayDiscount (params) {
    return ajax(`${gatewayApi}/v1/systemsettings/getOfflineReplayDiscount`, 'get', { params })
  },
  // 获取购物车
  getShoppingCart (params) {
    return ajax(`${gatewayApi}/v1/cart/get`, 'get', { params })
  },
  // 获取购物车数量
  getCartCount (params) {
    return ajax(`${gatewayApi}/v1/cart/cartCount`, 'get', { params })
  },
  // 加入购物车
  addCart (json) {
    return ajax(`${gatewayApi}/v1/cart/add`, 'post', { json })
  },
  // 删除购物车
  delCart (params) {
    return ajax(`${gatewayApi}/v1/cart/del`, 'get', { params })
  },
  // 直播推荐课程列表
  recommendList (params) {
    return ajax(`${adminApi}/v1/admin/Live/getLive`, 'get', { params })
  },
  // 直播推荐发送
  recommendSend (data) {
    return ajax(`${adminApi}/v1/admin/PushLive/pushMsg`, 'post', { data })
  },
  // 选择题统计
  recommendStatistics (params) {
    return ajax(`${gatewayApi}/v1/roomquestion/statistics`, 'get', { params })
  },
  // 获取发送网页信息
  getRecommendSend (data) {
    return ajax(`${zhixinApi}/v1/PushLive/getById`, 'post', { data })
  },
  // 获取答题id题目信息
  getQuestionById (params) {
    return ajax(`${zhixinApi}/v1/roomquestion/getQuestionById`, 'get', { params })
  },
  // 获取答题提交记录
  getSubmitList (params) {
    return ajax(`${gatewayApi}/v1/roomquestion/getSubmitList`, 'get', { params })
  },
  // 获取回放推荐
  getPlayBackInfo (params) {
    return ajax(`${zhixinApi}/v1/PushLive/getInfo`, 'get', { params })
  },
  // 保存回放
  saveReplayPoint (data) {
    return ajax(`${adminApi}/v1/admin/PushLive/replayPoint`, 'post', { data })
  },
  // 结束答题
  finishAnswer (data) {
    return ajax(`${adminApi}/v1/admin/PushLive/finishAnswer`, 'post', { data })
  },
  // 学情信息
  studyStation (params) {
    return ajax(`${gatewayApi}/v1/live/study`, 'get', { params })
  },
  // 质子领取页面
  getProton (data) {
    return ajax(`${gatewayApi}/v3/user/userReceiveProton`, 'post', { data })
  },
  pagedOrders (params) {
    return ajax(`${gatewayApi}/v3/charge/pagedOrders`, 'get', { params })
  },
  queryOrderNew (params) {
    return ajax(`${gatewayApi}/v3/charge/queryOrderNew`, 'get', { params })
  },
  getPushLiveInfo (params) {
    return ajax(`${zhixinApi}/v1/PushLive/getInfo`, 'get', { params })
  },
  submitAnswer (json) {
    return ajax(`${gatewayApi}/v1/roomquestion/submitAnswer`, 'post', { json })
  },
  getCurrentQuestion (params) {
    return ajax(`${gatewayApi}/v1/roomquestion/currentQuestion`, 'get', { params })
  },
  getUserSeeQuestion (params) {
    return ajax(`${gatewayApi}/v1/roomquestion/userSeeQuestion`, 'get', { params })
  },
  // 联报详情
  getUnionByUnionId (params) {
    return ajax(`${gatewayApi}/v3/marketing/getUnionByUnionId`, 'get', { params })
  },
  getUnionByUnionIdInfo (params) {
    return ajax(`${gatewayApi}/v3/marketing/getUnionByUnionIds`, 'get', { params })
  },
  canGoodsBuyUnion (params) {
    return ajax(`${gatewayApi}/v3/marketing/canGoodsBuyUnion`, 'get', { params })
  }
}

function ajax (url, method, options) {
  const { params = {}, data = {}, json } = options || {}
  return new Promise((resolve, reject) => {
    axios.defaults.withCredentials = true
    axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'
    if (params.msgUrl || data.msgUrl || url.indexOf('upload-images') > -1 || url.indexOf('/admin/') > -1) {
      delete params.msgUrl
      delete data.msgUrl
      delete axios.defaults.headers['X-Requested-With']
    }
    axios({ url, method, params, data: json || qs.stringify(data) }).then((res) => {
      resolve(res)
    }, (res) => {
      reject(res)
    })
  })
}

function rawRequest (url, method, options) {
  return new Request().ajax(method, url, options)
}

export default api
